<template>
  <ckeditor
    :name="name"
    :id="name"
    v-model="content"
  />
</template>

<script>
  import ckeditor from '../../vendor/ckeditor';

  export default {
    props: ['props'],

    components: {
      ckeditor,
    },

    data() {
      return {
        name: this.props.name,
        content: JSON.parse(this.props.value).data,
      };
    },

    created() {
      //
    },
  };
</script>

<style scoped>

</style>
